import React, { Component, Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import AppRoutes from './AppRoutes';
import { Home } from './components/Home';
import { Privacy } from './components/Privacy';
import { CompanyOffer } from './components/CompanyOffer';
import { Business } from './components/business/Main';
import { Booking } from './components/Booking';
import { UserCalendar } from './components/Calendar';
import { UserOrders } from './components/Orders';
import { ConfigCompany } from './components/config/Company';
import { ConfigUsers } from './components/config/Users';
import { ConfigServices } from './components/config/Services';
import { ConfigResources } from './components/config/Resources';
import { ConfigCalendar } from './components/config/Calendar';
import { ConfigProfiles } from './components/config/Profiles';
import { ConfigQRcode } from './components/config/QRcode';
import { ChartDay } from './components/charts/Day';
import { ChartResource } from './components/charts/Resource';
import { ChartUser } from './components/charts/User';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import { ApplicationPaths, LoginActions, LogoutActions } from './components/api-authorization/ApiAuthorizationConstants';

import { Login } from './components/api-authorization/Login'
import { Logout } from './components/api-authorization/Logout'

import './custom.css'
import { Restaurant } from './components/business/Restaurant';
import { Rent } from './components/business/Rent';
import { Event } from './components/business/Event';
import { Hotel } from './components/business/Hotel';
import { Coworking } from './components/business/Coworking';
import { Beauty } from './components/business/Beauty';
import { Sport } from './components/business/Sport';
import { Auto } from './components/business/Auto';
import { Fitness } from './components/business/Fitness';
import { Master } from './components/business/Master';

export default class App extends Component {
  render () {
    return (
      <Layout>
        <Switch>
          <Route exact path='/' component={Home}></Route>
          <Route path='/booking/:companyId?/:serviceId?' component={Booking} />
          <Route path='/privacy' component={Privacy} />
          <Route path='/companyoffer' component={CompanyOffer} />
          <Route path='/business/restaurant' component={Restaurant} />
          <Route path='/business/rent' component={Rent} />
          <Route path='/business/event' component={Event} />
          <Route path='/business/hotel' component={Hotel} />
          <Route path='/business/coworking' component={Coworking} />
          <Route path='/business/beauty' component={Beauty} />
          <Route path='/business/sport' component={Sport} />
          <Route path='/business/auto' component={Auto} />
          <Route path='/business/fitness' component={Fitness} />
          <Route path='/business/master' component={Master} />
          <Route path='/business' component={Business} />
          <AuthorizeRoute path='/calendar/:userId?' component={UserCalendar} />
          <AuthorizeRoute path='/orders/:userId?' component={UserOrders} />
          <AuthorizeRoute path='/configcompany/:companyId?' component={ConfigCompany} />
          <AuthorizeRoute path='/configusers/:companyId?' component={ConfigUsers} />
          <AuthorizeRoute path='/configservices/:companyId?' component={ConfigServices} />
          <AuthorizeRoute path='/configresources/:companyId?' component={ConfigResources} />
          <AuthorizeRoute path='/configcalendar/:companyId?' component={ConfigCalendar} />
          <AuthorizeRoute path='/configparams/:companyId?' component={ConfigProfiles} />
          <AuthorizeRoute path='/configcharts/day/:companyId?' component={ChartDay} />
          <AuthorizeRoute path='/configcharts/resource/:companyId?' component={ChartResource} />
          <AuthorizeRoute path='/configcharts/user/:companyId?' component={ChartUser} />
          <AuthorizeRoute path='/configqrcode/:companyId?' component={ConfigQRcode} />
          <Fragment>
            <Route path={ApplicationPaths.Login}><Login action={LoginActions.Login}/></Route>
            <Route path={ApplicationPaths.LoginFailed} render={() => loginAction(LoginActions.LoginFailed)} />
            <Route path={ApplicationPaths.LoginCallback}><Login action={LoginActions.LoginCallback}/></Route>
            <Route path={ApplicationPaths.Profile} render={() => loginAction(LoginActions.Profile)} />
            <Route path={ApplicationPaths.Register}><Login action={LoginActions.Register}/></Route>
            <Route path={ApplicationPaths.LogOut} render={() => logoutAction(LogoutActions.Logout)} />
            <Route path={ApplicationPaths.LogOutCallback} render={() => logoutAction(LogoutActions.LogoutCallback)} />
            <Route path={ApplicationPaths.LoggedOut} render={() => logoutAction(LogoutActions.LoggedOut)} />
          </Fragment>
        </Switch>
      </Layout>
    );
  }
}

          /*<Routes>
            {AppRoutes.map((route, index) => {
            const { element, requireAuth, ...rest } = route;
            return <Route key={index} {...rest} component={requireAuth ? <AuthorizeRoute {...rest} element={element} /> : element} />;
          })}
          </Routes>*/

function withParams(Component, history) {
  return (<Component history={history} />);
}

function loginAction(name) {
    return (<Login action={name}></Login>);
}

function logoutAction(name) {
    return (<Logout action={name}></Logout>);
}
